import styled from 'styled-components/macro'

export const StyledRadioButton = styled.input`
  appearance: none;
  border-radius: var(--radius-circle);
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  font-family: inherit;
  font-weight: var(--font-weight-regular);

  border: 1px solid var(--border-default);
  transition: 0.2s all linear;
  outline: none;
  margin-right: 1rem;

  &:checked {
    border: 5px solid var(--action-primary);
    background-color: var(--surface-card);
  }
`
export const RadioButtonLabel = styled.label`
  display: inline-flex;
  align-items: center;
  font-weight: var(--font-weight-regular);
  font-size: var(--mantine-font-size-md);
  min-height: 3.5rem;
  color: var(--text-strong);
`

export const RadioButtonWrap = styled.div`
  padding: 0 1rem;
  &:active,
  &:hover,
  &:focus,
  &:focus-within {
    background-color: var(--row-hover);
    cursor: pointer;
  }

  &.all-the-way-left {
    padding-left: 0;
  }
`
